import React, { useRef, useState } from 'react';

import './form.css';
import { api, getTenant, getUserName } from '../../../hooks';
import { IBLSpinLoader } from '../../IBLSpinLoader';

const MediaUpload = ({setDocuments}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isResume, setIsResume] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size > 26214400) {
      // 25MB in bytes
      window.alert('File size should be less than 25MB');
      return;
    }
    setSelectedFile(file); // Update selected file on change
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    handleFileChange({ target: { files: [file] } });
  };

  const handleSubmit = (file) => {
    if (file) {
      const formData = new FormData();
      if (isResume) {
        formData.append('resume', file);
      } else {
        formData.append('additional_files', file);
        formData.append('file_type_portfolio_sample.pdf', 'portfolio');
      }
      formData.append('user', getUserName());
      const DEFAULT_TENANT_TO_USE = process.env.REACT_APP_IBL_PROFILE_RESUME_FEATURE_TENANT_TO_USE_WITH_ENDPOINTS ?? getTenant()
      formData.append('platform', DEFAULT_TENANT_TO_USE);


      setIsUploading(true);
      setErrorMessage('');
      api.ibldmplatform.uploadResume(
        { org: DEFAULT_TENANT_TO_USE, userID: getUserName() },
        formData,
        (data) => {
          setIsUploading(false);
          setSelectedFile(null); // Update selected file after successful upload
          setErrorMessage('');
          setDocuments(data?.files || []);
        },
        (error) => {
          setIsUploading(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          window.alert('Error uploading media. Please try again later.');
          console.error(error);
        },
      );
    }
  };

  return (
    <div className="w-layout-vflex flex-block-54">
      {isUploading ? (
        <IBLSpinLoader  size={40}/>
      ) : (
        <>
          <div
            className="w-layout-vflex flex-block-53"
            onClick={() => {
              if (fileInputRef.current) {
                fileInputRef.current.click();
              }
            }}
            onDrop={handleFileDrop}
            onDragOver={(e) => e.preventDefault()}
          >
            <img
              src="https://cdn.prod.website-files.com/6596e21ac435cac3c66baad8/66ed8d4a46959beea57b0cd6_upload.svg"
              loading="lazy"
              alt=""
              className="image-233"
            />
            <div className="text-block-405">
              Drag and drop your file here <br />
              (Up to 25MB)
            </div>
          </div>
          {selectedFile && (
            <div className="selectedFileContainer">
              <p>Selected file:</p>
              <p>{selectedFile.name}</p>
              <label
                htmlFor="isResume"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <input
                  type="checkbox"
                  id="isResume"
                  name="isResume"
                  checked={isResume}
                  onChange={() => {
                    if (selectedFile.type === 'application/pdf') {
                      setIsResume(!isResume);
                    } else {
                      window.alert('Only PDF files can be marked as resume.');
                      //   remove the selected file here
                      setSelectedFile(null);
                    }
                  }}
                  style={{ marginRight: '8px' }}
                />
                This is a resume (PDF only)
              </label>
            </div>
          )}
          <a
            href="#"
            className="button-7 w-button"
            onClick={(e) => {
              e.preventDefault()
              handleSubmit(selectedFile)
            }}
          >
            Upload
          </a>

          <input
            type="file"
            accept={isResume ? '.pdf' : '.pdf,.doc,.docx,.jpeg,.png'}
            onChange={handleFileChange}
            ref={fileInputRef}
            id="fileInput"
            style={{ display: 'none' }}
          />
        </>
      )}
    </div>

  );
};

export default MediaUpload;